import { makeStyle } from '../../utils';
import { OYO_THEME } from '../../resources/colors';
import view from '../../Enums';
import { columnCenter, blackOutline, blackMedium } from '../../resources/styles';

const styles = {};

styles['mf_container'] = makeStyle({width:"100%%",height:"100%"},{},view.MOBILE,{overflowY:'scroll'});

styles['mf_head'] = makeStyle({
    backgroundColor:OYO_THEME,width:'100%',height:'15%',position:'sticky',display:'flex',alignItems:'flex-end',
    boxSizing:'border-box',
    padding:'15px'
});

styles['oyo_white'] = makeStyle({},{height:30},view.MOBILE,{height:20});

styles['sathi_text'] = makeStyle({fontWeight:900,color:'white',marginLeft:'auto'},{fontSize:'28px'},view.MOBILE,{fontSize:'16px'});

const headText = {color:'white'};

styles['oyo_text'] = makeStyle({...headText});

styles['mf_body'] = makeStyle({
    display:'flex',
    borderTop:`2px ${blackOutline.color} solid`,
    backgroundColor:'rgba(0,0,0,.05)'
},{
    height:'-webkit-fill-available',
    margin:'20px',
    boxSizing:"border-box",
    
},view.MOBILE,{flexDirection:'column',padding:15});

styles['profile'] = makeStyle({...columnCenter},{
    flex:4,marginTop:'50px',
    height:'75%',
    borderRight:`2px ${blackOutline.color} solid`
},view.MOBILE);

styles['avatar'] = makeStyle({
    height:'200px',width:'200px',color:'black',
    border:'0.5px solid'
});

const boxStyle = {
    fontWeight:300,
    backgroundColor:blackOutline.color,
    padding:'15px',
    boxSizing:'border-box',
    overflow:'hidden'
};

styles['profile_box']=makeStyle({
    ...boxStyle,
    textAlign:'center',
    marginTop:'20px',
    padding:'20px'
});

styles['description'] = makeStyle({
    ...columnCenter,marginTop:'50px',
    
},{flex:6,boxSizing:'border-box',padding:'0 7%',height:'75%'},view.MOBILE);



styles['description_top_box'] = makeStyle({width:'100%'},{display:'flex'},view.MOBILE);
styles['contact_info_box'] = makeStyle({...boxStyle},{minWidth:'40%',boxSizing:'border-box'},view.MOBILE);
styles['address_box'] = makeStyle({...boxStyle},{width:'40%',marginLeft:'auto',boxSizing:'border-box'});
styles['description_text_box'] = makeStyle({marginTop:30,textAlign:'justify',width:'100%'});

styles['bottom_btns_container'] = makeStyle({},{alignSelf:'flex-end',marginTop:'auto',marginBottom:'15px'},view.MOBILE,{marginTop:15,textAlign:'center'});
styles['contact_box'] = makeStyle({backgroundColor:OYO_THEME,color:'white',borderRadius:5,marginTop:10},{fontSize:16,padding:'10px 20px'},view.MOBILE,{padding:'10px',fontSize:14});
styles['become_oyo_sathi_box'] = makeStyle({backgroundColor:OYO_THEME,color:'white',borderRadius:5,marginTop:10},{fontSize:16,padding:'10px 20px',marginLeft:'20px'},view.MOBILE,{padding:'10px',marginLeft:'5px',fontSize:14});

styles['']=makeStyle({});

export default styles;